import axios from "axios";
import { default as BASE } from "../config";

export default axios.create({
  //baseURL: "http://t-mel04app06.travel.local/rest/export/json"
  baseURL: BASE.CONFIG.VERA_BASE,
});
